<template>
  <div>
    <b-row>
      <b-col cols="1">
        <small v-if="selectedProduct">
          <b-link @click="handleGoToStoreFrontClick">
            Back to Shopping
          </b-link></small
        >
      </b-col>
      <b-col cols="6" offset="4">
        <h2 @click="handleGoToStoreFrontClick" style="cursor:pointer">
          SHOP- {{ pageId }}
        </h2>
      </b-col>
      <b-col v-if="pageId != 'Checkout'">
        <div @click="handleShoppingCartClick" class="shoppingCart-wrapper-btn">
          <img
            v-if="shoppingCart.length > 0"
            src="@/assets/resourceBlocks/shopping-cart-filled.png"
          />
          <img v-else src="@/assets/resourceBlocks/shopping-cart.png" />
          <span>{{ shoppingCart.length }}</span>
        </div>
      </b-col>
    </b-row>
    <storefront
      v-if="pageId === 'Store'"
      :products="products"
      @product-selected="handleProductSelected"
      @add-to-cart="handleAddToCart"
      @update-cart="handleUpdateCart"
    />
    <product-details
      v-else-if="pageId === 'Product Details' && selectedProduct"
      :product="selectedProduct"
      @add-to-cart="handleAddToCart"
      @buy-now="handleBuyNow"
      @product-increment="handleProductIncrement"
      @product-decrement="handleProductDecrement"
    />
    <view-cart
      v-else-if="pageId === 'Cart'"
      :shopping-cart="shoppingCart"
      :total-amount="total"
      @quantity-minus="handleMinusQuantity"
      @quantity-plus="handlePlusQuantity"
      @product-selected="handleProductSelected"
      @remove-from-cart="handleRemoveFromCart"
      @go-to-checkout="handleGoToCheckout"
      @go-to-storefront="handleGoToStoreFrontClick"
    />
    <checkout
      v-else-if="pageId === 'Checkout'"
      :shopping-cart="shoppingCart"
      :total-amount="total"
      @remove-from-cart="handleRemoveFromCart"
    />
  </div>
</template>

<script>
import Storefront from "./storefront";
import ProductDetails from "./productDetails";
import ViewCart from "./viewCart";
import Checkout from "./checkout";
export default {
  name: "DisplayShop",
  components: {
    Storefront,
    ProductDetails,
    ViewCart,
    Checkout
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pageId: "Store", //Product Details, checkout
      selectedProduct: null,
      shoppingCart: [],
      shoppingCartTotal: 0,
      email: "",
      phoneNumber: null,
      notification: {
        name: "Active",
        type: "btns",
        text: "Enable if you want the resource to be active in your cprner",
        value: false
      }
    };
  },
  computed: {
    toolsFromPublishing() {
      return this.publishing &&
        this.publishing.tools &&
        Array.isArray(this.publishing.tools)
        ? this.publishing.tools
        : [];
    },
    thisTool() {
      return this.toolsFromPublishing.filter(aTool => {
        return aTool.toolId === this.resource.toolId;
      })[0];
    },
    settings() {
      return this.thisTool && this.thisTool.data && this.thisTool.data.settings
        ? this.thisTool.data.settings
        : null;
    },
    products() {
      return this.settings &&
        this.settings.products &&
        Array.isArray(this.settings.products)
        ? this.settings.products
        : [];
    },
    filteredProducts() {
      return this.products;
    },
    total() {
      if (this.shoppingCart.length > 0) {
        return this.shoppingCart
          .map(item => item.totalPrice)
          .reduce((total, amount) => total + amount);
      } else {
        return 0;
      }
    }
  },
  methods: {
    handleMinusQuantity(product) {
      console.log("Minus Quantity");
      if (product.productQuantity > 1) {
        product.productQuantity -= 1;
        product.totalPrice -= product.productQuantity * product.price;
      } else {
        this.handleRemoveFromCart();
      }
    },
    handlePlusQuantity(product) {
      console.log("plus it3");
      //TODO Check Max Quantity
      const existingProduct = this.shoppingCart.filter(aCartProduct => {
        return aCartProduct.id == product.id;
      });
      existingProduct.productQuantity += 1;
      existingProduct.totalPrice -=
        existingProduct.productQuantity * existingProduct.price;
    },
    handleGoToStoreFrontClick() {
      this.selectedProduct = null;
      this.pageId = "Store";
    },
    handleGoToCheckout() {
      this.pageId = "Checkout";
    },
    handleProductSelected(product) {
      console.log(`Product is ${product}`);

      this.selectedProduct = product;
      this.pageId = "Product Details";
    },
    handleUpdateCart(item) {
      this.shoppingCart.push(item);
      this.total = this.shoppingCartTotal;
    },
    handleShoppingCartClick() {
      this.pageId = "Cart";
    },
    handleEmptyCart() {
      this.shoppingCart = [];
      this.total = 0;
    },
    handleAddToCart(product) {
      const existingProduct = this.shoppingCart.filter(aCartProduct => {
        return aCartProduct.id == product.id;
      });

      if (Array.isArray(existingProduct) && existingProduct.length > 0) {
        existingProduct[0].productQuantity++;
        existingProduct[0].totalPrice += product.price ? product.price : 0;
      } else {
        const productToAdd = product;
        productToAdd.productQuantity = 1;
        productToAdd.totalPrice = product.price ? product.price : 0;
        console.log(`are we ready now?`);
        this.shoppingCart.push(productToAdd);
      }
    },
    handleRemoveFromCart(product) {
      let index = this.shoppingCart.indexOf(product);
      this.shoppingCart.splice(index, 1);
    },
    handleBuyNow(product) {
      alert(`Buy Now${product}`);
    },
    handleProductIncrement(product, itemNumber) {
      alert(`Product ${product} Item ${itemNumber}`);
    },
    handleProductDecrement(product, itemNumber) {
      alert(`Product ${product} Item ${itemNumber}`);
    },
    handleChange(changeMade) {
      console.log(changeMade);
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
